import React from "react"
import styled from "styled-components"
import { Check, theme } from "@omnichannel/ace-b2b-elements"
import useWindowDimensions from "../helpers/windowDimensions"

const Spacer = styled.div`
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`

const DropShadow = styled.div`
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: .4rem;
  border-radius: 0;
  width: auto;
  cursor: ${props => (props.clickable ? "pointer" : "initial")};
`

const WebView = styled.div`
  display: inherit;
  @media (max-width: 767px) {
    display: none;
  }
`

const MobileView = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: inherit;
  }
`

const FilterItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0.8rem 0.8rem .8rem 2.2rem;
  cursor: pointer;
  align-items: center;
  width: 100%;
`

const FilterItem = styled.div`
  font-size: 1.4rem;
  color: #3e3f42;
  line-height: 2rem;
  vertical-align: middle;
  text-transform: capitalize;
  width:90%;
  @media (min-width: 768px) {
    /* font-size: 1.4rem;
    width:90%; */
    font-size: 1.6rem;
  }
`

const IconContainer = styled.div`
  cursor: ${props => (props.cursor ? props.cursor : "initial")};
`

const CheckboxWrapperBox = styled.div`
    width: 5%;
`

const FilterOption = props => {
  const { width } = useWindowDimensions()
  const { name, onClick, selected } = props
  return (
    <FilterItemContainer onClick={onClick}>
      <CheckboxWrapperBox>
        {selected ? (
          <Check
            width={width > 767 ? 12 : 10}
            height={width > 767 ? 12 : 10}
            // color={"#C2171D"}
            color={theme.default.primary}
          />
        ) : <Spacer height={width > 767 ? '12px' : '10px'} />
        }
      </CheckboxWrapperBox>
      <Spacer width={".4rem"} />
      <FilterItem>{name && name.toLowerCase()}</FilterItem>
    </FilterItemContainer>
  )
}

export { Spacer, DropShadow, WebView, MobileView, IconContainer, FilterOption }
